import BaseService from '@/api/services/BaseService';

const API = {
  RESOURCE: 'https://api.giphy.com/v1/gifs',
  KEY: 'LhyU7RLoBRCstq1nvNV2o351PQqAGBkj',
  LIMIT: 24
};

export default class GiphyService extends BaseService {
  static getTrending(offset = 0) {
    const URI = `${API.RESOURCE}/trending?&api_key=${API.KEY}&offset=${offset}&limit=${API.LIMIT}`;
    return this.$http.get(URI).then(({ data }) => data.data);
  }

  static search(searchString, offset = 0) {
    const URI = `${API.RESOURCE}/search?&api_key=${API.KEY}&q=${searchString}&offset=${offset}&limit=${API.LIMIT}`;
    return this.$http.get(URI).then(({ data }) => data.data);
  }
}
